import vars from "../helpers";

const init = () => {
	const $project = vars.$document.find('.projects');
	let $nav = $project.find('.projects__link');

	const tab = (e) => {
		e.preventDefault();
		const $this = $(e.currentTarget);
		const $allTab = $project.find('.projects__tab');
		const $currentTav = $project.find(`.projects__tab[data-tab="${$this.attr('href')}"]`);
		gsap.timeline().to($allTab, 0.5, {
			opacity: 0,
			y: 100,
			clearProps: true,
		}).call(() => {
			$allTab.addClass('is-hidden');
			$nav.removeClass('is-active');
			$this.addClass('is-active');
			$currentTav.removeClass('is-hidden');
		}).from($currentTav, 0.5, {
			opacity: 0,
			y: 100,
			clearProps: true,
		});
	};

	$nav.on('click', tab);
};

export default {
	init
};
